import { VTable } from 'roosterjs-editor-dom';
import { cacheGetContentSearcher, clearContentSearcherCache } from 'roosterjs-editor-core';
import { editTable, formatTable, replaceWithNode } from 'roosterjs-editor-api';
import { Paste } from 'roosterjs-editor-plugins';
import PluginUtils from '../store/schema/PluginUtils';

export default function createPluginUtils(
    editorDiv: HTMLDivElement,
    pastePlugin: Paste
): PluginUtils {
    return {
        cacheGetContentSearcher,
        clearContentSearcherCache,
        replaceWithNode,
        editTable,
        formatTable,
        pasteOriginal: clipboardData => pastePlugin.pasteOriginal(clipboardData),
        pasteText: clipboardData => pastePlugin.pasteText(clipboardData),
        createVTable: (td: HTMLTableCellElement) => new VTable(td),
        observeMutation: getObjserveMutationFunc(editorDiv),
    };
}

function getObjserveMutationFunc(editorDiv: HTMLDivElement) {
    return (callback: MutationCallback, options?: MutationObserverInit) => {
        if (typeof MutationObserver != 'undefined') {
            const observer = new MutationObserver(callback);
            observer.observe(editorDiv, options);
            return () => {
                observer.disconnect();
            };
        } else {
            return () => {};
        }
    };
}
